import React from "react";

function LoadingWidget() {

  return (
    <>
        <div className="loaderTyping w-auto">
          <span></span>
          <span></span>
          <span></span>
        </div>
    </>
  );
}

export default LoadingWidget;
